import { TFunction } from 'i18next';

import {
  CustomerListColumn,
  CustomerListMatchingLimits,
  MatchingRulesIssue,
  MatchingRulesProblem,
} from '~/utils/customerListMatchingRules';

/** The sentence the form shows for one of its issues. */
export const describeMatchingRulesIssue = ({
  t,
  issue,
  columns,
  limits,
}: {
  t: TFunction;
  issue: MatchingRulesIssue;
  columns: CustomerListColumn[];
  limits: CustomerListMatchingLimits;
}) => {
  switch (issue.problem) {
    case MatchingRulesProblem.NoRules:
      return t('aiInsights.a2ui.matchingRules.nothingMatched');
    case MatchingRulesProblem.CollidingColumnNames:
      // Column names are the file's own text; React escapes them, so i18next mustn't as well
      return t('aiInsights.a2ui.matchingRules.issues.inconsistentMatchingColumnName', {
        interpolation: { escapeValue: false },
        columns: columns
          .filter(({ index }) => issue.columnIndexes?.includes(index))
          .map(({ columnName }) => columnName)
          .join(', '),
      });
    case MatchingRulesProblem.TooManyRules:
      return t('aiInsights.a2ui.matchingRules.issues.tooManyMatchingRules', { max: limits.maxRules });
    case MatchingRulesProblem.TooManyFields:
      return t('aiInsights.a2ui.matchingRules.issues.tooManyMatchingRuleFields', { max: limits.maxFieldsPerRule });
    default:
      return t(`aiInsights.a2ui.matchingRules.issues.${issue.problem}`);
  }
};
